<template>
  <div>
    <div class="row">
      <div class="px-3 col-12 pb-4">
        <GmapMap
            :center='center'
            :options="{
                   zoomControl: true,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: false,
                   disableDefaultUi: false,
                      }"
            :zoom='10'
            style='width:100%;  height: 400px;'>
          <GmapMarker
              v-for="(m, index) in markers"
              :key="index"
              :icon="{ url: m.icon,
                scaledSize: { width: 45, height: 45}   }"
              :position="m.position"
              @click="markerClick(m.vendorID,m.name,m.description,m.date,m.icon,m.isVerified)"
          />
        </GmapMap>
      </div>
    </div>

    <v-bottom-sheet v-model="vendorDetailModal" class="bottom-sheet" width="600">
      <v-sheet
          v-if="isDetailLoaded"
          class="rounded-t-xl">
        <div class="row  align-items-center mx-1">
          <div class="col-12 text-left">
            <v-btn icon @click="vendorDetailModal =false">
              <i class="fa-solid fa-circle-xmark fa-xl"></i>
            </v-btn>
          </div>
          <router-link :to="{path:'StoreProfile',query:{VendorID:id}}" class="col-2 pt-0 d-block">
            <v-avatar size="45">
              <img v-if="icon !== null" :src="(icon)" alt="تصویر فروشکاه">
              <i v-else class="fas fa-circle-user fa-4x"></i>
            </v-avatar>
          </router-link>
          <router-link :to="{path:'StoreProfile',query:{VendorID:id}}" class="col-6 pt-0 d-block">
                  <span class="font-weight-bold mr-1" dir="ltr"> {{ name }} <i v-if="isVerified"
                                                                               class="fa-solid fa-badge-check mr-1"></i> </span>
            <div class="text-truncate font12px m-0 bio-text" v-html="description"></div>
          </router-link>
          <div class="col-4 pt-0">
            <v-btn v-if='!isFollowed' elevation="0" small
                   @click="followVendor(id)">دنبال کردن
            </v-btn>
            <v-btn v-else-if="isFollowed" color="primary"
                   elevation="0" small
                   @click="followVendor(id)">دنبال شد
            </v-btn>
          </div>
        </div>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
export default {
  name: "PaymentsHomesMap",
  props: ['markers'],
  data: () => ({
    vendorDetailModal: false,
    searchKeyWord: null,
    center: {lat: 35.699936, lng: 51.390377},
    text: "",
    currentPlace: null,
    date: null,
    description: null,
    name: null,
    id: null,
    icon: null,
    isDetailLoaded: false,
    isFollowed: false,
    isVerified: null
  }),
  mounted() {

  },
  methods: {
    markerClick(id, name, desc, date, icon, isVerified) {
      let followings = this.$store.getters.getUserFollowings
      if (followings.find(x => x.VendorID === id) !== undefined) {
        this.isFollowed = true
      }

      this.id = id;
      this.name = name;
      this.description = desc;
      this.date = date;
      this.icon = icon
      this.isVerified = isVerified
      this.isDetailLoaded = true
      this.vendorDetailModal = true
    },
    followVendor(id) {
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.isFollowed = !this.isFollowed
              let payload = {id: id, type: 2}
              this.$store.commit('addOrRemoveFollowingItemToList', payload)
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
  }
}
</script>

<style scoped>

</style>
